/*! @azure/msal-common v14.14.0 2024-07-23 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.14.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
